export const envMapKeys = {
  favicon: {
    backend: "admin_dashboard_favicon",
    frontend: "VITE_FAVICON",
  },
  title: {
    backend: "admin_dashboard_main_title",
    frontend: "VITE_MAIN_TITLE",
  },
  meta_title: {
    backend: "admin_dashboard_meta_title",
    frontend: "VITE_META_TITLE",
  },
  logo: { backend: "admin_dashboard_logo", frontend: "VITE_LOGO" },
  organization_id: {
    backend: "admin_dashboard_organization_id",
    frontend: "VITE_ORGANIZATION_ID",
  },

  placeholder_small: {
    backend: "admin_dashboard_placeholder_small",
    frontend: "VITE_PLACEHOLDER_SMALL",
  },
  placeholder_large: {
    backend: "admin_dashboard_placeholder_large",
    frontend: "VITE_PLACEHOLDER_LARGE",
  },
  address: {
    backend: "admin_dashboard_address",
    frontend: "VITE_ADDRESS",
  },

  api: { backend: "admin_dashboard_api", frontend: "VITE_API" },
  api_private_key: {
    backend: "admin_dashboard_api_private_key",
    frontend: "VITE_API_PRIVATE_KEY",
  },

  api_public_key: {
    backend: "admin_dashboard_api_public_key",
    frontend: "VITE_API_PUBLIC_KEY",
  },
  cloudinary_cloud_name: {
    backend: "admin_dashboard_cloudinary_cloud_name",
    frontend: "VITE_CLOUDINARY_CLOUD_NAME",
  },
  cloudinary_image_upload_preset: {
    backend: "admin_dashboard_cloudinary_image_upload_preset",
    frontend: "VITE_CLOUDINARY_IMAGE_UPLOAD_PRESET",
  },
  cloudinary_video_upload_preset: {
    backend: "admin_dashboard_cloudinary_video_upload_preset",
    frontend: "VITE_CLOUDINARY_VIDEO_UPLOAD_PRESET",
  },

  cloudinary_upload_preset: {
    backend: "admin_dashboard_cloudinary_upload_preset",
    frontend: "VITE_CLOUDINARY_UPLOAD_PRESET",
  },
  country_code: {
    backend: "admin_dashboard_country_code",
    frontend: "VITE_COUNTRY_CODE",
  },

  decrypt_iv: {
    backend: "admin_dashboard_decrypt_iv",
    frontend: "VITE_DECRYPT_IV",
  },
  decrypt_key: {
    backend: "admin_dashboard_decrypt_key",
    frontend: "VITE_DECRYPT_KEY",
  },
  environment: {
    backend: "admin_dashboard_environment",
    frontend: "VITE_ENVIRONMENT",
  },
  google_map_api: {
    backend: "admin_dashboard_google_map_api",
    frontend: "VITE_GOOGLE_MAP_API",
  },
  google_tracking_api: {
    backend: "admin_dashboard_google_tracking_api",
    frontend: "VITE_GOOGLE_TRACKING_API",
  },
  lat: { backend: "admin_dashboard_lat", frontend: "VITE_LAT" },
  lng: { backend: "admin_dashboard_lng", frontend: "VITE_LNG" },
  loading: {
    backend: "admin_dashboard_loading",
    frontend: "VITE_LOADING",
  },
  password_salt: {
    backend: "admin_dashboard_password_salt",
    frontend: "VITE_PASSWORD_SALT",
  },
  placeholder: {
    backend: "admin_dashboard_placeholder",
    frontend: "VITE_PLACEHOLDER",
  },
  spree_base_url: {
    backend: "admin_dashboard_spree_base_url",
    frontend: "VITE_SPREE_BASE_URL",
  },
  theme_token_api: {
    backend: "admin_dashboard_theme_token_api",
    frontend: "VITE_THEME_TOKEN_API",
  },
  theme_token_api_key: {
    backend: "admin_dashboard_theme_token_api_key",
    frontend: "VITE_THEME_TOKEN_API_KEY",
  },
  user_dashboard: {
    backend: "admin_dashboard_user_dashboard",
    frontend: "VITE_USER_DASHBOARD",
  },
  intercom: {
    // key name is user_dashboard_intercom_app_id instead of admin_dashboard_intercom_app_id to match the BE variable
    // this done so BE doesn't have to save two different keys with the same value
    backend: "user_dashboard_intercom_app_id",
    frontend: "VITE_INTERCOM_APP_ID",
  },
  bee_client_id: {
    backend: "admin_dashboard_bee_client_id",
    frontend: "VITE_BEE_CLIENT_ID",
  },
  bee_client_secret: {
    backend: "admin_dashboard_bee_client_secret",
    frontend: "VITE_BEE_CLIENT_SECRET",
  },
  bee_page_builder_client_id: {
    backend: "admin_dashboard_bee_page_builder_client_id",
    frontend: "VITE_PAGE_BUILDER_CLIENT_ID",
  },
  bee_page_builder_client_secret: {
    backend: "admin_dashboard_bee_page_builder_client_secret",
    frontend: "VITE_PAGE_BUILDER_CLIENT_SECRET",
  },
} as const;
